import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableDelegate, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { ICompanyDTO } from '@modeso/types__aumico-lib-companies-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import debug from 'debug';
import { BehaviorSubject } from 'rxjs';
import { localizationKeys } from '../../constants/localizationKeys';
import { ICompaniesTableFields } from '../../interfaces/ICompaniesTableFields.interface';
import { CompaniesProvider } from '../../provider/companies.provider';
@UntilDestroy()
@Component({
    selector: 'aumico-companies-list-component',
    templateUrl: 'companies-list.component.html',
    styleUrls: ['companies-list.component.scss'],
})
export class CompaniesListComponent implements OnInit, ITableDelegate {
    @Input() public set injectedProviderSetter(injectedProvider: CompaniesProvider) {
        if (injectedProvider) {
            this.provider = injectedProvider;
        }
    }
    @Input() userPreferredNumberOfDocumentsPerPage: number | undefined;

    protected subscriptions = [];
    options: ITableOptions;
    local = localizationKeys;
    companies: ICompanyDTO[] = [];
    data: ICompaniesTableFields[];
    @Input() currentLanguage = 'de-ch';
    @Input() defaultLanguage = 'de-ch';

    @Output() editButtonClicked: EventEmitter<string> = new EventEmitter();

    @Output() numberOfDocumentsPerPageChanged = new EventEmitter<number>();

    @Input() filterSubject?: BehaviorSubject<string>;

    constructor(private provider: CompaniesProvider, private localizedTexts: I18NextService) {
        this.applyLocalizations();
    }

    ngOnInit(): void {
        this.subscriptions.push(this.provider.getCompanies$().subscribe(this.handleGetCompanies.bind(this)));
    }

    private applyLocalizations(): void {
        this.prepareFields();
    }

    private prepareFields(): void {
        this.options = {
            columns: [
                {
                    name: 'select',
                },
                {
                    name: this.localizedTexts.t(this.local.aumico_companies_table_label_company_name) as string,
                    type: 'text',
                    property: 'name',
                    flex: 30,
                },
                {
                    name: this.localizedTexts.t(
                        this.local.aumico_companies_table_label_company_street_and_number,
                    ) as string,
                    type: 'text',
                    property: 'street',
                    flex: 10,
                },
                {
                    name: this.localizedTexts.t(this.local.aumico_companies_table_label_company_postal_code) as string,
                    type: 'text',
                    property: 'zip',
                    flex: 10,
                },
                {
                    name: this.localizedTexts.t(this.local.aumico_companies_table_label_company_location) as string,
                    type: 'text',
                    property: 'city',
                    flex: 10,
                },
                {
                    name: this.localizedTexts.t(this.local.aumico_companies_table_label_company_legal_status) as string,
                    type: 'text',
                    property: 'legalform',
                    flex: 10,
                },
            ],
            rowClickAction: {
                property: '_id',
                action: 'edit',
            },
        };
    }

    private handleGetCompanies(companies: ICompanyDTO[]): void {
        if (companies != null) {
            this.companies = companies;
            this.data = this.mapICompanyToListModel(companies);
        }
    }

    private mapICompanyToListModel(companies: ICompanyDTO[]): ICompaniesTableFields[] {
        const companiesTableList: ICompaniesTableFields[] = [];
        companies.forEach((company) => {
            let legalFormName: string;
            const isLegalFormHasCaptionWithCurrentLanguage = company.legalform.text[this.currentLanguage] != null;
            if (isLegalFormHasCaptionWithCurrentLanguage) {
                legalFormName = company.legalform.text[this.currentLanguage];
            } else {
                legalFormName = company.legalform.text[this.defaultLanguage];
            }

            const companiesTableItem: ICompaniesTableFields = {
                _id: company._id,
                name: company.name ? company.name : '-',
                street: company.street ? company.street : '-',
                zip: company.zip ? company.zip : '-',
                city: company.city ? company.city : '-',
                legalform: legalFormName,
            };
            companiesTableList.push(companiesTableItem);
        });

        return companiesTableList;
    }

    onRowButtonClicked(id: string, action?: string): void {
        debug(`1 Row with Id ${id} clicked for action ${action}`);
        if (action === 'edit') {
            this.editButtonClicked.emit(id);
        }
    }

    onMenuItemClick(action: string, selectedRows: SelectionModel<any>): void {
        throw new Error('Method not implemented.');
    }

    public onPageSizeChanged(pageSize: number): void {
        this.numberOfDocumentsPerPageChanged.emit(pageSize);
    }
}
